// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/organizations/firstparty/v1/organization.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../google/protobuf/timestamp";

/** Core banking system used by the organization */
export const ApiCoreBankingSystem = {
  /** CORE_BANKING_SYSTEM_UNSPECIFIED - Unspecified core banking system */
  CORE_BANKING_SYSTEM_UNSPECIFIED: "CORE_BANKING_SYSTEM_UNSPECIFIED",
  /**
   * Qonto core banking system
   */
  qonto: "qonto",
  /**
   * Treezor core banking system
   */
  treezor: "treezor",
} as const;

export type ApiCoreBankingSystem = typeof ApiCoreBankingSystem[keyof typeof ApiCoreBankingSystem];

export namespace ApiCoreBankingSystem {
  export type CORE_BANKING_SYSTEM_UNSPECIFIED = typeof ApiCoreBankingSystem.CORE_BANKING_SYSTEM_UNSPECIFIED;
  export type qonto = typeof ApiCoreBankingSystem.qonto;
  export type treezor = typeof ApiCoreBankingSystem.treezor;
}

export function apiCoreBankingSystemFromJSON(object: any): ApiCoreBankingSystem {
  switch (object) {
    case 0:
    case "CORE_BANKING_SYSTEM_UNSPECIFIED":
      return ApiCoreBankingSystem.CORE_BANKING_SYSTEM_UNSPECIFIED;
    case 1:
    case "qonto":
      return ApiCoreBankingSystem.qonto;
    case 2:
    case "treezor":
      return ApiCoreBankingSystem.treezor;
    default:
      return ApiCoreBankingSystem.CORE_BANKING_SYSTEM_UNSPECIFIED;
  }
}

export function apiCoreBankingSystemToJSON(object: ApiCoreBankingSystem): string {
  switch (object) {
    case ApiCoreBankingSystem.CORE_BANKING_SYSTEM_UNSPECIFIED:
      return "CORE_BANKING_SYSTEM_UNSPECIFIED";
    case ApiCoreBankingSystem.qonto:
      return "qonto";
    case ApiCoreBankingSystem.treezor:
      return "treezor";
    default:
      return "CORE_BANKING_SYSTEM_UNSPECIFIED";
  }
}

/** Price plan recurrence chosen by the user */
export const ApiPriceRecurrence = {
  /** PRICE_RECURRENCE_UNSPECIFIED - Unspecified price recurrence */
  PRICE_RECURRENCE_UNSPECIFIED: "PRICE_RECURRENCE_UNSPECIFIED",
  /**
   * Monthly billing
   */
  monthly: "monthly",
  /**
   * Annual billing
   */
  annual: "annual",
} as const;

export type ApiPriceRecurrence = typeof ApiPriceRecurrence[keyof typeof ApiPriceRecurrence];

export namespace ApiPriceRecurrence {
  export type PRICE_RECURRENCE_UNSPECIFIED = typeof ApiPriceRecurrence.PRICE_RECURRENCE_UNSPECIFIED;
  export type monthly = typeof ApiPriceRecurrence.monthly;
  export type annual = typeof ApiPriceRecurrence.annual;
}

export function apiPriceRecurrenceFromJSON(object: any): ApiPriceRecurrence {
  switch (object) {
    case 0:
    case "PRICE_RECURRENCE_UNSPECIFIED":
      return ApiPriceRecurrence.PRICE_RECURRENCE_UNSPECIFIED;
    case 1:
    case "monthly":
      return ApiPriceRecurrence.monthly;
    case 2:
    case "annual":
      return ApiPriceRecurrence.annual;
    default:
      return ApiPriceRecurrence.PRICE_RECURRENCE_UNSPECIFIED;
  }
}

export function apiPriceRecurrenceToJSON(object: ApiPriceRecurrence): string {
  switch (object) {
    case ApiPriceRecurrence.PRICE_RECURRENCE_UNSPECIFIED:
      return "PRICE_RECURRENCE_UNSPECIFIED";
    case ApiPriceRecurrence.monthly:
      return "monthly";
    case ApiPriceRecurrence.annual:
      return "annual";
    default:
      return "PRICE_RECURRENCE_UNSPECIFIED";
  }
}

/** Legal country of the organization */
export const ApiLegalCountry = {
  /** LEGAL_COUNTRY_UNSPECIFIED - Unspecified legal country */
  LEGAL_COUNTRY_UNSPECIFIED: "LEGAL_COUNTRY_UNSPECIFIED",
  /**
   * Germany
   */
  DE: "DE",
  /**
   * Spain
   */
  ES: "ES",
  /**
   * France
   */
  FR: "FR",
  /**
   * Italy
   */
  IT: "IT",
  /**
   * Austria
   */
  AT: "AT",
  /**
   * Belgium
   */
  BE: "BE",
  /**
   * Netherlands
   */
  NL: "NL",
  /**
   * Portugal
   */
  PT: "PT",
} as const;

export type ApiLegalCountry = typeof ApiLegalCountry[keyof typeof ApiLegalCountry];

export namespace ApiLegalCountry {
  export type LEGAL_COUNTRY_UNSPECIFIED = typeof ApiLegalCountry.LEGAL_COUNTRY_UNSPECIFIED;
  export type DE = typeof ApiLegalCountry.DE;
  export type ES = typeof ApiLegalCountry.ES;
  export type FR = typeof ApiLegalCountry.FR;
  export type IT = typeof ApiLegalCountry.IT;
  export type AT = typeof ApiLegalCountry.AT;
  export type BE = typeof ApiLegalCountry.BE;
  export type NL = typeof ApiLegalCountry.NL;
  export type PT = typeof ApiLegalCountry.PT;
}

export function apiLegalCountryFromJSON(object: any): ApiLegalCountry {
  switch (object) {
    case 0:
    case "LEGAL_COUNTRY_UNSPECIFIED":
      return ApiLegalCountry.LEGAL_COUNTRY_UNSPECIFIED;
    case 1:
    case "DE":
      return ApiLegalCountry.DE;
    case 2:
    case "ES":
      return ApiLegalCountry.ES;
    case 3:
    case "FR":
      return ApiLegalCountry.FR;
    case 4:
    case "IT":
      return ApiLegalCountry.IT;
    case 5:
    case "AT":
      return ApiLegalCountry.AT;
    case 6:
    case "BE":
      return ApiLegalCountry.BE;
    case 7:
    case "NL":
      return ApiLegalCountry.NL;
    case 8:
    case "PT":
      return ApiLegalCountry.PT;
    default:
      return ApiLegalCountry.LEGAL_COUNTRY_UNSPECIFIED;
  }
}

export function apiLegalCountryToJSON(object: ApiLegalCountry): string {
  switch (object) {
    case ApiLegalCountry.LEGAL_COUNTRY_UNSPECIFIED:
      return "LEGAL_COUNTRY_UNSPECIFIED";
    case ApiLegalCountry.DE:
      return "DE";
    case ApiLegalCountry.ES:
      return "ES";
    case ApiLegalCountry.FR:
      return "FR";
    case ApiLegalCountry.IT:
      return "IT";
    case ApiLegalCountry.AT:
      return "AT";
    case ApiLegalCountry.BE:
      return "BE";
    case ApiLegalCountry.NL:
      return "NL";
    case ApiLegalCountry.PT:
      return "PT";
    default:
      return "LEGAL_COUNTRY_UNSPECIFIED";
  }
}

/** Management type for GbR legal form */
export const ApiGbrManagementType = {
  /** GBR_MANAGEMENT_TYPE_UNSPECIFIED - Unspecified GbR management type */
  GBR_MANAGEMENT_TYPE_UNSPECIFIED: "GBR_MANAGEMENT_TYPE_UNSPECIFIED",
  /**
   * Single management
   */
  single: "single",
  /**
   * Joint management
   */
  joint: "joint",
} as const;

export type ApiGbrManagementType = typeof ApiGbrManagementType[keyof typeof ApiGbrManagementType];

export namespace ApiGbrManagementType {
  export type GBR_MANAGEMENT_TYPE_UNSPECIFIED = typeof ApiGbrManagementType.GBR_MANAGEMENT_TYPE_UNSPECIFIED;
  export type single = typeof ApiGbrManagementType.single;
  export type joint = typeof ApiGbrManagementType.joint;
}

export function apiGbrManagementTypeFromJSON(object: any): ApiGbrManagementType {
  switch (object) {
    case 0:
    case "GBR_MANAGEMENT_TYPE_UNSPECIFIED":
      return ApiGbrManagementType.GBR_MANAGEMENT_TYPE_UNSPECIFIED;
    case 1:
    case "single":
      return ApiGbrManagementType.single;
    case 2:
    case "joint":
      return ApiGbrManagementType.joint;
    default:
      return ApiGbrManagementType.GBR_MANAGEMENT_TYPE_UNSPECIFIED;
  }
}

export function apiGbrManagementTypeToJSON(object: ApiGbrManagementType): string {
  switch (object) {
    case ApiGbrManagementType.GBR_MANAGEMENT_TYPE_UNSPECIFIED:
      return "GBR_MANAGEMENT_TYPE_UNSPECIFIED";
    case ApiGbrManagementType.single:
      return "single";
    case ApiGbrManagementType.joint:
      return "joint";
    default:
      return "GBR_MANAGEMENT_TYPE_UNSPECIFIED";
  }
}

/** Flow type for the organization registration */
export const ApiFlowType = {
  /** FLOW_TYPE_UNSPECIFIED - Unspecified flow type */
  FLOW_TYPE_UNSPECIFIED: "FLOW_TYPE_UNSPECIFIED",
  /**
   * Seamless flow
   */
  seamless: "seamless",
  /**
   * Manual flow
   */
  manual: "manual",
} as const;

export type ApiFlowType = typeof ApiFlowType[keyof typeof ApiFlowType];

export namespace ApiFlowType {
  export type FLOW_TYPE_UNSPECIFIED = typeof ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  export type seamless = typeof ApiFlowType.seamless;
  export type manual = typeof ApiFlowType.manual;
}

export function apiFlowTypeFromJSON(object: any): ApiFlowType {
  switch (object) {
    case 0:
    case "FLOW_TYPE_UNSPECIFIED":
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
    case 1:
    case "seamless":
      return ApiFlowType.seamless;
    case 2:
    case "manual":
      return ApiFlowType.manual;
    default:
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  }
}

export function apiFlowTypeToJSON(object: ApiFlowType): string {
  switch (object) {
    case ApiFlowType.FLOW_TYPE_UNSPECIFIED:
      return "FLOW_TYPE_UNSPECIFIED";
    case ApiFlowType.seamless:
      return "seamless";
    case ApiFlowType.manual:
      return "manual";
    default:
      return "FLOW_TYPE_UNSPECIFIED";
  }
}

/** Contract signing status */
export const ApiContractSignStatus = {
  /** CONTRACT_SIGN_STATUS_UNSPECIFIED - Unspecified contract sign status */
  CONTRACT_SIGN_STATUS_UNSPECIFIED: "CONTRACT_SIGN_STATUS_UNSPECIFIED",
  /**
   * Contract signing is pending
   */
  pending: "pending",
  /**
   * Contract signing had a validation error
   */
  validation_error: "validation_error",
  /**
   * Contract signing is completed
   */
  completed: "completed",
} as const;

export type ApiContractSignStatus = typeof ApiContractSignStatus[keyof typeof ApiContractSignStatus];

export namespace ApiContractSignStatus {
  export type CONTRACT_SIGN_STATUS_UNSPECIFIED = typeof ApiContractSignStatus.CONTRACT_SIGN_STATUS_UNSPECIFIED;
  export type pending = typeof ApiContractSignStatus.pending;
  export type validation_error = typeof ApiContractSignStatus.validation_error;
  export type completed = typeof ApiContractSignStatus.completed;
}

export function apiContractSignStatusFromJSON(object: any): ApiContractSignStatus {
  switch (object) {
    case 0:
    case "CONTRACT_SIGN_STATUS_UNSPECIFIED":
      return ApiContractSignStatus.CONTRACT_SIGN_STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiContractSignStatus.pending;
    case 2:
    case "validation_error":
      return ApiContractSignStatus.validation_error;
    case 3:
    case "completed":
      return ApiContractSignStatus.completed;
    default:
      return ApiContractSignStatus.CONTRACT_SIGN_STATUS_UNSPECIFIED;
  }
}

export function apiContractSignStatusToJSON(object: ApiContractSignStatus): string {
  switch (object) {
    case ApiContractSignStatus.CONTRACT_SIGN_STATUS_UNSPECIFIED:
      return "CONTRACT_SIGN_STATUS_UNSPECIFIED";
    case ApiContractSignStatus.pending:
      return "pending";
    case ApiContractSignStatus.validation_error:
      return "validation_error";
    case ApiContractSignStatus.completed:
      return "completed";
    default:
      return "CONTRACT_SIGN_STATUS_UNSPECIFIED";
  }
}

/** Organization represents an organization during the registration process */
export interface ApiOrganization {
  /** Unique identifier of the organization */
  readonly id: string;
  /** User ID associated with the organization */
  readonly userId: string;
  /** Array of stakeholder IDs associated with the organization */
  readonly stakeholderIds: readonly string[];
  /** Array of document IDs associated with the organization */
  readonly documentIds: readonly string[];
  /** True when there is a shortage of physical cards */
  readonly inCardShortage: boolean;
  /** UUIDv4 reference to a capital deposit payment from payment provider */
  readonly depositPaymentId?:
    | string
    | null
    | undefined;
  /** Indicates whether the organization CBS is Qonto or Treezor */
  readonly coreBankingSystem: ApiCoreBankingSystem;
  /** True when the organization's Creditsafe entry is empty */
  readonly unreferenced: boolean;
  /** Array of active feature flags */
  readonly features: readonly string[];
  /** The name of the organization */
  readonly name?:
    | string
    | null
    | undefined;
  /** True when the organization is under creation and should go through the capital deposit flow */
  readonly underRegistration?:
    | boolean
    | null
    | undefined;
  /** The code of the price plan chosen by the user at registration */
  readonly originalPricePlanCode?:
    | string
    | null
    | undefined;
  /** A discount code entered by the user when selecting their price plan */
  readonly originalVoucherCode?:
    | string
    | null
    | undefined;
  /** The recurrence chosen by the user at registration */
  readonly originalRecurrence?:
    | ApiPriceRecurrence
    | null
    | undefined;
  /** The named contact at the organization's address */
  readonly addressContactName?:
    | string
    | null
    | undefined;
  /** The first line of the organization's address */
  readonly addressLine1?:
    | string
    | null
    | undefined;
  /** The second line of the organization's address */
  readonly addressLine2?:
    | string
    | null
    | undefined;
  /** The organization's zipcode */
  readonly addressZipcode?:
    | string
    | null
    | undefined;
  /** The city where the organization is based */
  readonly addressCity?:
    | string
    | null
    | undefined;
  /** The two-letter ISO 3166-1 code of the organization's country */
  readonly addressCountry?:
    | string
    | null
    | undefined;
  /** The organization's Qonto-specific sector code */
  readonly sectorCode?:
    | string
    | null
    | undefined;
  /** The organization's Qonto-specific activity code */
  readonly activityCode?:
    | string
    | null
    | undefined;
  /** The organization's legally registered name as reported by Creditsafe */
  readonly legalName?:
    | string
    | null
    | undefined;
  /** The organization's legal form as reported by Creditsafe */
  readonly legalFormCreditsafeCode?:
    | string
    | null
    | undefined;
  /** INSEE NAF code as reported by Creditsafe */
  readonly legalSector?:
    | string
    | null
    | undefined;
  /** The organization's legal number as reported by Creditsafe (in France, this is the SIRET) */
  readonly legalNumber?:
    | string
    | null
    | undefined;
  /** The date on which the organization was registered as reported by Creditsafe */
  readonly legalRegistrationDate?:
    | string
    | null
    | undefined;
  /** The organization's VAT number */
  readonly legalTvaNumber?:
    | string
    | null
    | undefined;
  /** The total share capital of the organization as reported by Creditsafe (in cents) */
  readonly legalShareCapitalCents?:
    | number
    | null
    | undefined;
  /** The three-letter currency code of the legal_share_capital as reported by Creditsafe */
  readonly legalShareCapitalCurrency?:
    | string
    | null
    | undefined;
  /** The annual turnover range of the organization as reported by Creditsafe */
  readonly legalAnnualTurnOver?:
    | string
    | null
    | undefined;
  /** The net income range of the organization as reported by Creditsafe */
  readonly legalNetIncomeRange?:
    | string
    | null
    | undefined;
  /** The headcount of the organization as reported by Creditsafe */
  readonly legalNumberOfEmployeeRange?:
    | string
    | null
    | undefined;
  /** The organization's legal country */
  readonly legalCountry: ApiLegalCountry;
  /** The author of the organization's bylaws */
  readonly providerSource?:
    | string
    | null
    | undefined;
  /** The contact email address of the author of the organization's bylaws */
  readonly providerSourceContactEmail?:
    | string
    | null
    | undefined;
  /** Indicates an existing Qonto customer that the organization was referred by */
  readonly referralCode?:
    | string
    | null
    | undefined;
  /** Indicates that the tax residence of the organization may have CRS reporting requirements */
  readonly crsFlagged?:
    | boolean
    | null
    | undefined;
  /** The number of employees declared by the user during registration */
  readonly declaredNumberOfEmployeeRange?:
    | string
    | null
    | undefined;
  /** Whether the organization's activity is allowed or blacklisted by Qonto's policy */
  readonly allowedActivity?:
    | boolean
    | null
    | undefined;
  /** Turnover for the last year */
  readonly annualTurnover?:
    | string
    | null
    | undefined;
  /** Estimated number of transactions per year */
  readonly yearlyTransactionVolume?:
    | string
    | null
    | undefined;
  /** Estimated highest amount for single payment */
  readonly maxSinglePaymentAmount?:
    | number
    | null
    | undefined;
  /** Indicates what the Qonto account will be used for */
  readonly natureOfOperations: readonly string[];
  /** Creation timestamp */
  readonly createdAt:
    | Date
    | null;
  /** Management type of the organization, specific to GbR legal form */
  readonly gbrManagementType?:
    | ApiGbrManagementType
    | null
    | undefined;
  /** True when the organization is created from scratch */
  readonly companyCreationFromScratch?:
    | boolean
    | null
    | undefined;
  /** ID of the stakeholder with role owner */
  readonly ownerId: string;
  /** ID of the registration state associated to the organization */
  readonly registrationStateId?:
    | string
    | null
    | undefined;
  /** ID of the partner registration associated to the organization */
  readonly partnerRegistrationId?:
    | string
    | null
    | undefined;
  /** The current flow type of the organization */
  readonly flowType: ApiFlowType;
  /** ID of the organization on API that was upgraded from light to paid */
  readonly correlatedFreemiumToPaidUpgradeOrganizationId?:
    | string
    | null
    | undefined;
  /** The first line of the organization's operating office address */
  readonly operatingOfficeLine1?:
    | string
    | null
    | undefined;
  /** The second line of the organization's operating office address */
  readonly operatingOfficeLine2?:
    | string
    | null
    | undefined;
  /** The organization's operating office zipcode */
  readonly operatingOfficeZipcode?:
    | string
    | null
    | undefined;
  /** The city where the organization's operating office is based */
  readonly operatingOfficeCity?:
    | string
    | null
    | undefined;
  /** The two-letter ISO 3166-1 code of the organization's operating office country */
  readonly operatingOfficeCountry?:
    | string
    | null
    | undefined;
  /** The organization's business website */
  readonly websiteUrl?:
    | string
    | null
    | undefined;
  /** The organization's net equity amount */
  readonly netEquityAmount?:
    | string
    | null
    | undefined;
  /** The organization's share capital amount */
  readonly shareCapitalAmount?:
    | string
    | null
    | undefined;
  /** The organization's net income amount */
  readonly netIncomeAmount?:
    | string
    | null
    | undefined;
  /** The source categories from where the organization's share capital is coming from */
  readonly shareCapitalOrigin: readonly string[];
  /** The freeform text for the organization's share capital origin */
  readonly shareCapitalOriginOther?:
    | string
    | null
    | undefined;
  /** The source categories from where the organization's income is coming from */
  readonly sourcesOfIncome: readonly string[];
  /** The freeform text for the organization's sources of income */
  readonly sourcesOfIncomeOther?:
    | string
    | null
    | undefined;
  /** Countries of origin and destination of the funds */
  readonly countriesOfOperations: readonly string[];
  /** Indicates whether the organization is a non-profit entity */
  readonly nonProfit?:
    | boolean
    | null
    | undefined;
  /** The type of organization chosen by the user at the start of registration (e.g. freelancer, small_company, big_company, association, works_council) */
  readonly initialOrganizationType?:
    | string
    | null
    | undefined;
  /** The estimated annual turnover declared by the user during registration (in euros) */
  readonly estimatedAnnualTurnover?:
    | number
    | null
    | undefined;
  /** Whether any beneficial owner of the organization has been declared as a politically exposed person */
  readonly declaredPepInBeneficiaries?:
    | boolean
    | null
    | undefined;
  /** True when the user opted for uploading bylaws early with OCR pre-fill */
  readonly earlyBylawUpload?:
    | boolean
    | null
    | undefined;
  /** Countries where incoming transfers originate from */
  readonly incomingTransfersOrigin: readonly string[];
  /** Countries where outgoing transfers are sent to */
  readonly outgoingTransfersDestination: readonly string[];
  /** Typeform URL for the organization (computed, uses association_typeform_url as fallback) */
  readonly typeformUrl?:
    | string
    | null
    | undefined;
  /** Association-specific typeform URL */
  readonly associationTypeformUrl?:
    | string
    | null
    | undefined;
  /** Contract signing status */
  readonly contractSignStatus?:
    | ApiContractSignStatus
    | null
    | undefined;
  /** Business relationship types (e.g., suppliers, clients) */
  readonly businessRelationships: readonly string[];
  /** Freeform text for business relationships when "other" is selected */
  readonly businessRelationshipsOther?:
    | string
    | null
    | undefined;
  /** Business activity entity type */
  readonly businessActivityEntityType?:
    | string
    | null
    | undefined;
  /** Description of the organization's activity */
  readonly activityDescription?:
    | string
    | null
    | undefined;
  /** The categories of beneficiaries served by the organization (for associations/foundations) */
  readonly beneficiariesType: readonly string[];
  /** Freeform text for beneficiaries type when "other" is selected */
  readonly beneficiariesTypeOther?:
    | string
    | null
    | undefined;
  /** Business activity codes declared by the organization (e.g., for Spanish KYB) */
  readonly businessActivities: readonly string[];
  /** Creditsafe-prefilled field values, present when the organization was auto-filled from a Creditsafe lookup */
  readonly prefilled?:
    | ApiOrganizationPrefilled
    | null
    | undefined;
  /** Business activity status as reported by Creditsafe (IT only, e.g., "active", "inactive") */
  readonly businessStatus?:
    | string
    | null
    | undefined;
  /** Legal status of the organization as reported by Creditsafe (IT only, e.g., "active", "nonactive") */
  readonly companyStatus?:
    | string
    | null
    | undefined;
  /** Whether the company is tax resident in a country other than the Qonto entity country (FATCA/CRS) */
  readonly companyTaxResidentOutsideQontoEntityCountry?:
    | boolean
    | null
    | undefined;
  /** The two-letter ISO 3166-1 code of the company's additional tax residency country */
  readonly companyTaxResidencyCountry?:
    | string
    | null
    | undefined;
  /** The company's tax identification number (TIN) for the additional tax residency country */
  readonly companyTaxIdentificationNumber?: string | null | undefined;
}

/** Creditsafe-prefilled field values keyed by organization field name */
export interface ApiOrganizationPrefilled {
  /** The organization's legally registered name as reported by Creditsafe */
  readonly name?:
    | string
    | null
    | undefined;
  /** The organization's legal number as reported by Creditsafe (e.g., SIRET in France) */
  readonly legalNumber?:
    | string
    | null
    | undefined;
  /** The organization's legal form code as reported by Creditsafe */
  readonly legalFormCreditsafeCode?:
    | string
    | null
    | undefined;
  /** The date on which the organization was registered as reported by Creditsafe */
  readonly legalRegistrationDate?:
    | string
    | null
    | undefined;
  /** The organization's legally registered name as reported by Creditsafe */
  readonly legalName?:
    | string
    | null
    | undefined;
  /** INSEE NAF / ATECO code as reported by Creditsafe */
  readonly legalSector?:
    | string
    | null
    | undefined;
  /** The total share capital of the organization as reported by Creditsafe (in cents) */
  readonly legalShareCapitalCents?:
    | number
    | null
    | undefined;
  /** The annual turnover range of the organization as reported by Creditsafe */
  readonly legalAnnualTurnOver?:
    | string
    | null
    | undefined;
  /** The net income range of the organization as reported by Creditsafe */
  readonly legalNetIncomeRange?:
    | string
    | null
    | undefined;
  /** The headcount of the organization as reported by Creditsafe */
  readonly legalNumberOfEmployeeRange?:
    | string
    | null
    | undefined;
  /** The first line of the organization's legal address as reported by Creditsafe */
  readonly legalAddressLine1?:
    | string
    | null
    | undefined;
  /** The zipcode of the organization's legal address as reported by Creditsafe */
  readonly legalAddressZipcode?:
    | string
    | null
    | undefined;
  /** The city of the organization's legal address as reported by Creditsafe */
  readonly legalAddressCity?:
    | string
    | null
    | undefined;
  /** The first line of the organization's address */
  readonly addressLine1?:
    | string
    | null
    | undefined;
  /** The zipcode of the organization's address */
  readonly addressZipcode?:
    | string
    | null
    | undefined;
  /** The city of the organization's address */
  readonly addressCity?:
    | string
    | null
    | undefined;
  /** The two-letter ISO 3166-1 code of the organization's address country */
  readonly addressCountry?:
    | string
    | null
    | undefined;
  /** The organization's VAT number (Italy only) */
  readonly legalTvaNumber?:
    | string
    | null
    | undefined;
  /** Annual turnover range derived from Creditsafe financial data (format: "min-max") */
  readonly annualTurnover?:
    | string
    | null
    | undefined;
  /** Net income amount bracket derived from Creditsafe financial data */
  readonly netIncomeAmount?:
    | string
    | null
    | undefined;
  /** Share capital amount bracket derived from Creditsafe financial data */
  readonly shareCapitalAmount?:
    | string
    | null
    | undefined;
  /** Business activity status as reported by Creditsafe (IT only, e.g., "active", "inactive") */
  readonly businessStatus?:
    | string
    | null
    | undefined;
  /** Legal status of the organization as reported by Creditsafe (IT only, e.g., "active", "nonactive") */
  readonly companyStatus?: string | null | undefined;
}

export const ApiOrganization: MessageFns<ApiOrganization> = {
  fromJSON(object: any): ApiOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userId: isSet(object.user_id) ? globalThis.String(object.user_id) : "",
      stakeholderIds: globalThis.Array.isArray(object?.stakeholder_ids)
        ? object.stakeholder_ids.map((e: any) => globalThis.String(e))
        : [],
      documentIds: globalThis.Array.isArray(object?.document_ids)
        ? object.document_ids.map((e: any) => globalThis.String(e))
        : [],
      inCardShortage: isSet(object.in_card_shortage) ? globalThis.Boolean(object.in_card_shortage) : false,
      depositPaymentId: isSet(object.deposit_payment_id) ? globalThis.String(object.deposit_payment_id) : null,
      coreBankingSystem: isSet(object.core_banking_system)
        ? apiCoreBankingSystemFromJSON(object.core_banking_system)
        : ApiCoreBankingSystem.CORE_BANKING_SYSTEM_UNSPECIFIED,
      unreferenced: isSet(object.unreferenced) ? globalThis.Boolean(object.unreferenced) : false,
      features: globalThis.Array.isArray(object?.features) ? object.features.map((e: any) => globalThis.String(e)) : [],
      name: isSet(object.name) ? globalThis.String(object.name) : null,
      underRegistration: isSet(object.under_registration) ? globalThis.Boolean(object.under_registration) : null,
      originalPricePlanCode: isSet(object.original_price_plan_code)
        ? globalThis.String(object.original_price_plan_code)
        : null,
      originalVoucherCode: isSet(object.original_voucher_code) ? globalThis.String(object.original_voucher_code) : null,
      originalRecurrence: isSet(object.original_recurrence)
        ? apiPriceRecurrenceFromJSON(object.original_recurrence)
        : null,
      addressContactName: isSet(object.address_contact_name) ? globalThis.String(object.address_contact_name) : null,
      addressLine1: isSet(object.address_line_1) ? globalThis.String(object.address_line_1) : null,
      addressLine2: isSet(object.address_line_2) ? globalThis.String(object.address_line_2) : null,
      addressZipcode: isSet(object.address_zipcode) ? globalThis.String(object.address_zipcode) : null,
      addressCity: isSet(object.address_city) ? globalThis.String(object.address_city) : null,
      addressCountry: isSet(object.address_country) ? globalThis.String(object.address_country) : null,
      sectorCode: isSet(object.sector_code) ? globalThis.String(object.sector_code) : null,
      activityCode: isSet(object.activity_code) ? globalThis.String(object.activity_code) : null,
      legalName: isSet(object.legal_name) ? globalThis.String(object.legal_name) : null,
      legalFormCreditsafeCode: isSet(object.legal_form_creditsafe_code)
        ? globalThis.String(object.legal_form_creditsafe_code)
        : null,
      legalSector: isSet(object.legal_sector) ? globalThis.String(object.legal_sector) : null,
      legalNumber: isSet(object.legal_number) ? globalThis.String(object.legal_number) : null,
      legalRegistrationDate: isSet(object.legal_registration_date)
        ? globalThis.String(object.legal_registration_date)
        : null,
      legalTvaNumber: isSet(object.legal_tva_number) ? globalThis.String(object.legal_tva_number) : null,
      legalShareCapitalCents: isSet(object.legal_share_capital_cents)
        ? globalThis.Number(object.legal_share_capital_cents)
        : null,
      legalShareCapitalCurrency: isSet(object.legal_share_capital_currency)
        ? globalThis.String(object.legal_share_capital_currency)
        : null,
      legalAnnualTurnOver: isSet(object.legal_annual_turn_over)
        ? globalThis.String(object.legal_annual_turn_over)
        : null,
      legalNetIncomeRange: isSet(object.legal_net_income_range)
        ? globalThis.String(object.legal_net_income_range)
        : null,
      legalNumberOfEmployeeRange: isSet(object.legal_number_of_employee_range)
        ? globalThis.String(object.legal_number_of_employee_range)
        : null,
      legalCountry: isSet(object.legal_country)
        ? apiLegalCountryFromJSON(object.legal_country)
        : ApiLegalCountry.LEGAL_COUNTRY_UNSPECIFIED,
      providerSource: isSet(object.provider_source) ? globalThis.String(object.provider_source) : null,
      providerSourceContactEmail: isSet(object.provider_source_contact_email)
        ? globalThis.String(object.provider_source_contact_email)
        : null,
      referralCode: isSet(object.referral_code) ? globalThis.String(object.referral_code) : null,
      crsFlagged: isSet(object.crs_flagged) ? globalThis.Boolean(object.crs_flagged) : null,
      declaredNumberOfEmployeeRange: isSet(object.declared_number_of_employee_range)
        ? globalThis.String(object.declared_number_of_employee_range)
        : null,
      allowedActivity: isSet(object.allowed_activity) ? globalThis.Boolean(object.allowed_activity) : null,
      annualTurnover: isSet(object.annual_turnover) ? globalThis.String(object.annual_turnover) : null,
      yearlyTransactionVolume: isSet(object.yearly_transaction_volume)
        ? globalThis.String(object.yearly_transaction_volume)
        : null,
      maxSinglePaymentAmount: isSet(object.max_single_payment_amount)
        ? globalThis.Number(object.max_single_payment_amount)
        : null,
      natureOfOperations: globalThis.Array.isArray(object?.nature_of_operations)
        ? object.nature_of_operations.map((e: any) => globalThis.String(e))
        : [],
      createdAt: isSet(object.created_at) ? fromJsonTimestamp(object.created_at) : null,
      gbrManagementType: isSet(object.gbr_management_type)
        ? apiGbrManagementTypeFromJSON(object.gbr_management_type)
        : null,
      companyCreationFromScratch: isSet(object.company_creation_from_scratch)
        ? globalThis.Boolean(object.company_creation_from_scratch)
        : null,
      ownerId: isSet(object.owner_id) ? globalThis.String(object.owner_id) : "",
      registrationStateId: isSet(object.registration_state_id) ? globalThis.String(object.registration_state_id) : null,
      partnerRegistrationId: isSet(object.partner_registration_id)
        ? globalThis.String(object.partner_registration_id)
        : null,
      flowType: isSet(object.flow_type) ? apiFlowTypeFromJSON(object.flow_type) : ApiFlowType.FLOW_TYPE_UNSPECIFIED,
      correlatedFreemiumToPaidUpgradeOrganizationId: isSet(object.correlated_freemium_to_paid_upgrade_organization_id)
        ? globalThis.String(object.correlated_freemium_to_paid_upgrade_organization_id)
        : null,
      operatingOfficeLine1: isSet(object.operating_office_line_1)
        ? globalThis.String(object.operating_office_line_1)
        : null,
      operatingOfficeLine2: isSet(object.operating_office_line_2)
        ? globalThis.String(object.operating_office_line_2)
        : null,
      operatingOfficeZipcode: isSet(object.operating_office_zipcode)
        ? globalThis.String(object.operating_office_zipcode)
        : null,
      operatingOfficeCity: isSet(object.operating_office_city) ? globalThis.String(object.operating_office_city) : null,
      operatingOfficeCountry: isSet(object.operating_office_country)
        ? globalThis.String(object.operating_office_country)
        : null,
      websiteUrl: isSet(object.website_url) ? globalThis.String(object.website_url) : null,
      netEquityAmount: isSet(object.net_equity_amount) ? globalThis.String(object.net_equity_amount) : null,
      shareCapitalAmount: isSet(object.share_capital_amount) ? globalThis.String(object.share_capital_amount) : null,
      netIncomeAmount: isSet(object.net_income_amount) ? globalThis.String(object.net_income_amount) : null,
      shareCapitalOrigin: globalThis.Array.isArray(object?.share_capital_origin)
        ? object.share_capital_origin.map((e: any) => globalThis.String(e))
        : [],
      shareCapitalOriginOther: isSet(object.share_capital_origin_other)
        ? globalThis.String(object.share_capital_origin_other)
        : null,
      sourcesOfIncome: globalThis.Array.isArray(object?.sources_of_income)
        ? object.sources_of_income.map((e: any) => globalThis.String(e))
        : [],
      sourcesOfIncomeOther: isSet(object.sources_of_income_other)
        ? globalThis.String(object.sources_of_income_other)
        : null,
      countriesOfOperations: globalThis.Array.isArray(object?.countries_of_operations)
        ? object.countries_of_operations.map((e: any) => globalThis.String(e))
        : [],
      nonProfit: isSet(object.non_profit) ? globalThis.Boolean(object.non_profit) : null,
      initialOrganizationType: isSet(object.initial_organization_type)
        ? globalThis.String(object.initial_organization_type)
        : null,
      estimatedAnnualTurnover: isSet(object.estimated_annual_turnover)
        ? globalThis.Number(object.estimated_annual_turnover)
        : null,
      declaredPepInBeneficiaries: isSet(object.declared_pep_in_beneficiaries)
        ? globalThis.Boolean(object.declared_pep_in_beneficiaries)
        : null,
      earlyBylawUpload: isSet(object.early_bylaw_upload) ? globalThis.Boolean(object.early_bylaw_upload) : null,
      incomingTransfersOrigin: globalThis.Array.isArray(object?.incoming_transfers_origin)
        ? object.incoming_transfers_origin.map((e: any) => globalThis.String(e))
        : [],
      outgoingTransfersDestination: globalThis.Array.isArray(object?.outgoing_transfers_destination)
        ? object.outgoing_transfers_destination.map((e: any) => globalThis.String(e))
        : [],
      typeformUrl: isSet(object.typeform_url) ? globalThis.String(object.typeform_url) : null,
      associationTypeformUrl: isSet(object.association_typeform_url)
        ? globalThis.String(object.association_typeform_url)
        : null,
      contractSignStatus: isSet(object.contract_sign_status)
        ? apiContractSignStatusFromJSON(object.contract_sign_status)
        : null,
      businessRelationships: globalThis.Array.isArray(object?.business_relationships)
        ? object.business_relationships.map((e: any) => globalThis.String(e))
        : [],
      businessRelationshipsOther: isSet(object.business_relationships_other)
        ? globalThis.String(object.business_relationships_other)
        : null,
      businessActivityEntityType: isSet(object.business_activity_entity_type)
        ? globalThis.String(object.business_activity_entity_type)
        : null,
      activityDescription: isSet(object.activity_description) ? globalThis.String(object.activity_description) : null,
      beneficiariesType: globalThis.Array.isArray(object?.beneficiaries_type)
        ? object.beneficiaries_type.map((e: any) => globalThis.String(e))
        : [],
      beneficiariesTypeOther: isSet(object.beneficiaries_type_other)
        ? globalThis.String(object.beneficiaries_type_other)
        : null,
      businessActivities: globalThis.Array.isArray(object?.business_activities)
        ? object.business_activities.map((e: any) => globalThis.String(e))
        : [],
      prefilled: isSet(object.prefilled) ? ApiOrganizationPrefilled.fromJSON(object.prefilled) : null,
      businessStatus: isSet(object.business_status) ? globalThis.String(object.business_status) : null,
      companyStatus: isSet(object.company_status) ? globalThis.String(object.company_status) : null,
      companyTaxResidentOutsideQontoEntityCountry: isSet(object.company_tax_resident_outside_qonto_entity_country)
        ? globalThis.Boolean(object.company_tax_resident_outside_qonto_entity_country)
        : null,
      companyTaxResidencyCountry: isSet(object.company_tax_residency_country)
        ? globalThis.String(object.company_tax_residency_country)
        : null,
      companyTaxIdentificationNumber: isSet(object.company_tax_identification_number)
        ? globalThis.String(object.company_tax_identification_number)
        : null,
    };
  },

  toJSON(message: ApiOrganization): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.userId !== undefined && message.userId !== null) {
      obj.user_id = message.userId;
    }
    if (message.stakeholderIds?.length) {
      obj.stakeholder_ids = message.stakeholderIds;
    }
    if (message.documentIds?.length) {
      obj.document_ids = message.documentIds;
    }
    if (message.inCardShortage !== undefined && message.inCardShortage !== null) {
      obj.in_card_shortage = message.inCardShortage;
    }
    if (message.depositPaymentId !== undefined && message.depositPaymentId !== null) {
      obj.deposit_payment_id = message.depositPaymentId;
    }
    if (message.coreBankingSystem !== undefined && message.coreBankingSystem !== null) {
      obj.core_banking_system = apiCoreBankingSystemToJSON(message.coreBankingSystem);
    }
    if (message.unreferenced !== undefined && message.unreferenced !== null) {
      obj.unreferenced = message.unreferenced;
    }
    if (message.features?.length) {
      obj.features = message.features;
    }
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.underRegistration !== undefined && message.underRegistration !== null) {
      obj.under_registration = message.underRegistration;
    }
    if (message.originalPricePlanCode !== undefined && message.originalPricePlanCode !== null) {
      obj.original_price_plan_code = message.originalPricePlanCode;
    }
    if (message.originalVoucherCode !== undefined && message.originalVoucherCode !== null) {
      obj.original_voucher_code = message.originalVoucherCode;
    }
    if (message.originalRecurrence !== undefined && message.originalRecurrence !== null) {
      obj.original_recurrence = apiPriceRecurrenceToJSON(message.originalRecurrence);
    }
    if (message.addressContactName !== undefined && message.addressContactName !== null) {
      obj.address_contact_name = message.addressContactName;
    }
    if (message.addressLine1 !== undefined && message.addressLine1 !== null) {
      obj.address_line_1 = message.addressLine1;
    }
    if (message.addressLine2 !== undefined && message.addressLine2 !== null) {
      obj.address_line_2 = message.addressLine2;
    }
    if (message.addressZipcode !== undefined && message.addressZipcode !== null) {
      obj.address_zipcode = message.addressZipcode;
    }
    if (message.addressCity !== undefined && message.addressCity !== null) {
      obj.address_city = message.addressCity;
    }
    if (message.addressCountry !== undefined && message.addressCountry !== null) {
      obj.address_country = message.addressCountry;
    }
    if (message.sectorCode !== undefined && message.sectorCode !== null) {
      obj.sector_code = message.sectorCode;
    }
    if (message.activityCode !== undefined && message.activityCode !== null) {
      obj.activity_code = message.activityCode;
    }
    if (message.legalName !== undefined && message.legalName !== null) {
      obj.legal_name = message.legalName;
    }
    if (message.legalFormCreditsafeCode !== undefined && message.legalFormCreditsafeCode !== null) {
      obj.legal_form_creditsafe_code = message.legalFormCreditsafeCode;
    }
    if (message.legalSector !== undefined && message.legalSector !== null) {
      obj.legal_sector = message.legalSector;
    }
    if (message.legalNumber !== undefined && message.legalNumber !== null) {
      obj.legal_number = message.legalNumber;
    }
    if (message.legalRegistrationDate !== undefined && message.legalRegistrationDate !== null) {
      obj.legal_registration_date = message.legalRegistrationDate;
    }
    if (message.legalTvaNumber !== undefined && message.legalTvaNumber !== null) {
      obj.legal_tva_number = message.legalTvaNumber;
    }
    if (message.legalShareCapitalCents !== undefined && message.legalShareCapitalCents !== null) {
      obj.legal_share_capital_cents = Math.round(message.legalShareCapitalCents);
    }
    if (message.legalShareCapitalCurrency !== undefined && message.legalShareCapitalCurrency !== null) {
      obj.legal_share_capital_currency = message.legalShareCapitalCurrency;
    }
    if (message.legalAnnualTurnOver !== undefined && message.legalAnnualTurnOver !== null) {
      obj.legal_annual_turn_over = message.legalAnnualTurnOver;
    }
    if (message.legalNetIncomeRange !== undefined && message.legalNetIncomeRange !== null) {
      obj.legal_net_income_range = message.legalNetIncomeRange;
    }
    if (message.legalNumberOfEmployeeRange !== undefined && message.legalNumberOfEmployeeRange !== null) {
      obj.legal_number_of_employee_range = message.legalNumberOfEmployeeRange;
    }
    if (message.legalCountry !== undefined && message.legalCountry !== null) {
      obj.legal_country = apiLegalCountryToJSON(message.legalCountry);
    }
    if (message.providerSource !== undefined && message.providerSource !== null) {
      obj.provider_source = message.providerSource;
    }
    if (message.providerSourceContactEmail !== undefined && message.providerSourceContactEmail !== null) {
      obj.provider_source_contact_email = message.providerSourceContactEmail;
    }
    if (message.referralCode !== undefined && message.referralCode !== null) {
      obj.referral_code = message.referralCode;
    }
    if (message.crsFlagged !== undefined && message.crsFlagged !== null) {
      obj.crs_flagged = message.crsFlagged;
    }
    if (message.declaredNumberOfEmployeeRange !== undefined && message.declaredNumberOfEmployeeRange !== null) {
      obj.declared_number_of_employee_range = message.declaredNumberOfEmployeeRange;
    }
    if (message.allowedActivity !== undefined && message.allowedActivity !== null) {
      obj.allowed_activity = message.allowedActivity;
    }
    if (message.annualTurnover !== undefined && message.annualTurnover !== null) {
      obj.annual_turnover = message.annualTurnover;
    }
    if (message.yearlyTransactionVolume !== undefined && message.yearlyTransactionVolume !== null) {
      obj.yearly_transaction_volume = message.yearlyTransactionVolume;
    }
    if (message.maxSinglePaymentAmount !== undefined && message.maxSinglePaymentAmount !== null) {
      obj.max_single_payment_amount = Math.round(message.maxSinglePaymentAmount);
    }
    if (message.natureOfOperations?.length) {
      obj.nature_of_operations = message.natureOfOperations;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.created_at = message.createdAt.toISOString();
    }
    if (message.gbrManagementType !== undefined && message.gbrManagementType !== null) {
      obj.gbr_management_type = apiGbrManagementTypeToJSON(message.gbrManagementType);
    }
    if (message.companyCreationFromScratch !== undefined && message.companyCreationFromScratch !== null) {
      obj.company_creation_from_scratch = message.companyCreationFromScratch;
    }
    if (message.ownerId !== undefined && message.ownerId !== null) {
      obj.owner_id = message.ownerId;
    }
    if (message.registrationStateId !== undefined && message.registrationStateId !== null) {
      obj.registration_state_id = message.registrationStateId;
    }
    if (message.partnerRegistrationId !== undefined && message.partnerRegistrationId !== null) {
      obj.partner_registration_id = message.partnerRegistrationId;
    }
    if (message.flowType !== undefined && message.flowType !== null) {
      obj.flow_type = apiFlowTypeToJSON(message.flowType);
    }
    if (
      message.correlatedFreemiumToPaidUpgradeOrganizationId !== undefined &&
      message.correlatedFreemiumToPaidUpgradeOrganizationId !== null
    ) {
      obj.correlated_freemium_to_paid_upgrade_organization_id = message.correlatedFreemiumToPaidUpgradeOrganizationId;
    }
    if (message.operatingOfficeLine1 !== undefined && message.operatingOfficeLine1 !== null) {
      obj.operating_office_line_1 = message.operatingOfficeLine1;
    }
    if (message.operatingOfficeLine2 !== undefined && message.operatingOfficeLine2 !== null) {
      obj.operating_office_line_2 = message.operatingOfficeLine2;
    }
    if (message.operatingOfficeZipcode !== undefined && message.operatingOfficeZipcode !== null) {
      obj.operating_office_zipcode = message.operatingOfficeZipcode;
    }
    if (message.operatingOfficeCity !== undefined && message.operatingOfficeCity !== null) {
      obj.operating_office_city = message.operatingOfficeCity;
    }
    if (message.operatingOfficeCountry !== undefined && message.operatingOfficeCountry !== null) {
      obj.operating_office_country = message.operatingOfficeCountry;
    }
    if (message.websiteUrl !== undefined && message.websiteUrl !== null) {
      obj.website_url = message.websiteUrl;
    }
    if (message.netEquityAmount !== undefined && message.netEquityAmount !== null) {
      obj.net_equity_amount = message.netEquityAmount;
    }
    if (message.shareCapitalAmount !== undefined && message.shareCapitalAmount !== null) {
      obj.share_capital_amount = message.shareCapitalAmount;
    }
    if (message.netIncomeAmount !== undefined && message.netIncomeAmount !== null) {
      obj.net_income_amount = message.netIncomeAmount;
    }
    if (message.shareCapitalOrigin?.length) {
      obj.share_capital_origin = message.shareCapitalOrigin;
    }
    if (message.shareCapitalOriginOther !== undefined && message.shareCapitalOriginOther !== null) {
      obj.share_capital_origin_other = message.shareCapitalOriginOther;
    }
    if (message.sourcesOfIncome?.length) {
      obj.sources_of_income = message.sourcesOfIncome;
    }
    if (message.sourcesOfIncomeOther !== undefined && message.sourcesOfIncomeOther !== null) {
      obj.sources_of_income_other = message.sourcesOfIncomeOther;
    }
    if (message.countriesOfOperations?.length) {
      obj.countries_of_operations = message.countriesOfOperations;
    }
    if (message.nonProfit !== undefined && message.nonProfit !== null) {
      obj.non_profit = message.nonProfit;
    }
    if (message.initialOrganizationType !== undefined && message.initialOrganizationType !== null) {
      obj.initial_organization_type = message.initialOrganizationType;
    }
    if (message.estimatedAnnualTurnover !== undefined && message.estimatedAnnualTurnover !== null) {
      obj.estimated_annual_turnover = Math.round(message.estimatedAnnualTurnover);
    }
    if (message.declaredPepInBeneficiaries !== undefined && message.declaredPepInBeneficiaries !== null) {
      obj.declared_pep_in_beneficiaries = message.declaredPepInBeneficiaries;
    }
    if (message.earlyBylawUpload !== undefined && message.earlyBylawUpload !== null) {
      obj.early_bylaw_upload = message.earlyBylawUpload;
    }
    if (message.incomingTransfersOrigin?.length) {
      obj.incoming_transfers_origin = message.incomingTransfersOrigin;
    }
    if (message.outgoingTransfersDestination?.length) {
      obj.outgoing_transfers_destination = message.outgoingTransfersDestination;
    }
    if (message.typeformUrl !== undefined && message.typeformUrl !== null) {
      obj.typeform_url = message.typeformUrl;
    }
    if (message.associationTypeformUrl !== undefined && message.associationTypeformUrl !== null) {
      obj.association_typeform_url = message.associationTypeformUrl;
    }
    if (message.contractSignStatus !== undefined && message.contractSignStatus !== null) {
      obj.contract_sign_status = apiContractSignStatusToJSON(message.contractSignStatus);
    }
    if (message.businessRelationships?.length) {
      obj.business_relationships = message.businessRelationships;
    }
    if (message.businessRelationshipsOther !== undefined && message.businessRelationshipsOther !== null) {
      obj.business_relationships_other = message.businessRelationshipsOther;
    }
    if (message.businessActivityEntityType !== undefined && message.businessActivityEntityType !== null) {
      obj.business_activity_entity_type = message.businessActivityEntityType;
    }
    if (message.activityDescription !== undefined && message.activityDescription !== null) {
      obj.activity_description = message.activityDescription;
    }
    if (message.beneficiariesType?.length) {
      obj.beneficiaries_type = message.beneficiariesType;
    }
    if (message.beneficiariesTypeOther !== undefined && message.beneficiariesTypeOther !== null) {
      obj.beneficiaries_type_other = message.beneficiariesTypeOther;
    }
    if (message.businessActivities?.length) {
      obj.business_activities = message.businessActivities;
    }
    if (message.prefilled !== undefined && message.prefilled !== null) {
      obj.prefilled = ApiOrganizationPrefilled.toJSON(message.prefilled);
    }
    if (message.businessStatus !== undefined && message.businessStatus !== null) {
      obj.business_status = message.businessStatus;
    }
    if (message.companyStatus !== undefined && message.companyStatus !== null) {
      obj.company_status = message.companyStatus;
    }
    if (
      message.companyTaxResidentOutsideQontoEntityCountry !== undefined &&
      message.companyTaxResidentOutsideQontoEntityCountry !== null
    ) {
      obj.company_tax_resident_outside_qonto_entity_country = message.companyTaxResidentOutsideQontoEntityCountry;
    }
    if (message.companyTaxResidencyCountry !== undefined && message.companyTaxResidencyCountry !== null) {
      obj.company_tax_residency_country = message.companyTaxResidencyCountry;
    }
    if (message.companyTaxIdentificationNumber !== undefined && message.companyTaxIdentificationNumber !== null) {
      obj.company_tax_identification_number = message.companyTaxIdentificationNumber;
    }
    return obj;
  },
};

export const ApiOrganizationPrefilled: MessageFns<ApiOrganizationPrefilled> = {
  fromJSON(object: any): ApiOrganizationPrefilled {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : null,
      legalNumber: isSet(object.legal_number) ? globalThis.String(object.legal_number) : null,
      legalFormCreditsafeCode: isSet(object.legal_form_creditsafe_code)
        ? globalThis.String(object.legal_form_creditsafe_code)
        : null,
      legalRegistrationDate: isSet(object.legal_registration_date)
        ? globalThis.String(object.legal_registration_date)
        : null,
      legalName: isSet(object.legal_name) ? globalThis.String(object.legal_name) : null,
      legalSector: isSet(object.legal_sector) ? globalThis.String(object.legal_sector) : null,
      legalShareCapitalCents: isSet(object.legal_share_capital_cents)
        ? globalThis.Number(object.legal_share_capital_cents)
        : null,
      legalAnnualTurnOver: isSet(object.legal_annual_turn_over)
        ? globalThis.String(object.legal_annual_turn_over)
        : null,
      legalNetIncomeRange: isSet(object.legal_net_income_range)
        ? globalThis.String(object.legal_net_income_range)
        : null,
      legalNumberOfEmployeeRange: isSet(object.legal_number_of_employee_range)
        ? globalThis.String(object.legal_number_of_employee_range)
        : null,
      legalAddressLine1: isSet(object.legal_address_line_1) ? globalThis.String(object.legal_address_line_1) : null,
      legalAddressZipcode: isSet(object.legal_address_zipcode) ? globalThis.String(object.legal_address_zipcode) : null,
      legalAddressCity: isSet(object.legal_address_city) ? globalThis.String(object.legal_address_city) : null,
      addressLine1: isSet(object.address_line_1) ? globalThis.String(object.address_line_1) : null,
      addressZipcode: isSet(object.address_zipcode) ? globalThis.String(object.address_zipcode) : null,
      addressCity: isSet(object.address_city) ? globalThis.String(object.address_city) : null,
      addressCountry: isSet(object.address_country) ? globalThis.String(object.address_country) : null,
      legalTvaNumber: isSet(object.legal_tva_number) ? globalThis.String(object.legal_tva_number) : null,
      annualTurnover: isSet(object.annual_turnover) ? globalThis.String(object.annual_turnover) : null,
      netIncomeAmount: isSet(object.net_income_amount) ? globalThis.String(object.net_income_amount) : null,
      shareCapitalAmount: isSet(object.share_capital_amount) ? globalThis.String(object.share_capital_amount) : null,
      businessStatus: isSet(object.business_status) ? globalThis.String(object.business_status) : null,
      companyStatus: isSet(object.company_status) ? globalThis.String(object.company_status) : null,
    };
  },

  toJSON(message: ApiOrganizationPrefilled): unknown {
    const obj: any = {};
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.legalNumber !== undefined && message.legalNumber !== null) {
      obj.legal_number = message.legalNumber;
    }
    if (message.legalFormCreditsafeCode !== undefined && message.legalFormCreditsafeCode !== null) {
      obj.legal_form_creditsafe_code = message.legalFormCreditsafeCode;
    }
    if (message.legalRegistrationDate !== undefined && message.legalRegistrationDate !== null) {
      obj.legal_registration_date = message.legalRegistrationDate;
    }
    if (message.legalName !== undefined && message.legalName !== null) {
      obj.legal_name = message.legalName;
    }
    if (message.legalSector !== undefined && message.legalSector !== null) {
      obj.legal_sector = message.legalSector;
    }
    if (message.legalShareCapitalCents !== undefined && message.legalShareCapitalCents !== null) {
      obj.legal_share_capital_cents = Math.round(message.legalShareCapitalCents);
    }
    if (message.legalAnnualTurnOver !== undefined && message.legalAnnualTurnOver !== null) {
      obj.legal_annual_turn_over = message.legalAnnualTurnOver;
    }
    if (message.legalNetIncomeRange !== undefined && message.legalNetIncomeRange !== null) {
      obj.legal_net_income_range = message.legalNetIncomeRange;
    }
    if (message.legalNumberOfEmployeeRange !== undefined && message.legalNumberOfEmployeeRange !== null) {
      obj.legal_number_of_employee_range = message.legalNumberOfEmployeeRange;
    }
    if (message.legalAddressLine1 !== undefined && message.legalAddressLine1 !== null) {
      obj.legal_address_line_1 = message.legalAddressLine1;
    }
    if (message.legalAddressZipcode !== undefined && message.legalAddressZipcode !== null) {
      obj.legal_address_zipcode = message.legalAddressZipcode;
    }
    if (message.legalAddressCity !== undefined && message.legalAddressCity !== null) {
      obj.legal_address_city = message.legalAddressCity;
    }
    if (message.addressLine1 !== undefined && message.addressLine1 !== null) {
      obj.address_line_1 = message.addressLine1;
    }
    if (message.addressZipcode !== undefined && message.addressZipcode !== null) {
      obj.address_zipcode = message.addressZipcode;
    }
    if (message.addressCity !== undefined && message.addressCity !== null) {
      obj.address_city = message.addressCity;
    }
    if (message.addressCountry !== undefined && message.addressCountry !== null) {
      obj.address_country = message.addressCountry;
    }
    if (message.legalTvaNumber !== undefined && message.legalTvaNumber !== null) {
      obj.legal_tva_number = message.legalTvaNumber;
    }
    if (message.annualTurnover !== undefined && message.annualTurnover !== null) {
      obj.annual_turnover = message.annualTurnover;
    }
    if (message.netIncomeAmount !== undefined && message.netIncomeAmount !== null) {
      obj.net_income_amount = message.netIncomeAmount;
    }
    if (message.shareCapitalAmount !== undefined && message.shareCapitalAmount !== null) {
      obj.share_capital_amount = message.shareCapitalAmount;
    }
    if (message.businessStatus !== undefined && message.businessStatus !== null) {
      obj.business_status = message.businessStatus;
    }
    if (message.companyStatus !== undefined && message.companyStatus !== null) {
      obj.company_status = message.companyStatus;
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
